import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import { Table, Badge, Tabs, DatePicker, Input, Drawer, Dropdown } from "antd";
import { useDispatch, useSelector } from "react-redux";
import TransTab from "./TransTab";
import UserTab from "./UserTab";
// import { CloseOutlined, AudioOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { getBySearch, getVisitorAllHistory } from "../../redux/AllHistory/AllHistoryActions";
import { getPastMessages } from "../../redux/Chats/PastChatsActions";
import { SocketContext } from "../../context/socketContext";
import { visitorsUniqueKeyEqual } from "../../helpers/visitorId";
import { mergeVisitorProfile, visitorProfileMatches } from "../../helpers/visitorPastStats";
import { SOCKET_EVENTS } from "../../constants/socketEvents";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const { RangePicker } = DatePicker;

const Currenthistory = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.Auth.userData);
  const usertoken = useSelector((state) => state.Auth.token);
  const overAllUsers = useSelector((state) => state.Users.overAllUsers);
  const visitorData = useSelector((state) => state.ALLHistoryReducer.dataH);
  const isLoadingH = useSelector((state) => state.ALLHistoryReducer.isLoadingH);
  // const [selectedRow, setSelectedRow] = useState(null);
  const [isShow, setisShow] = useState(false);
  const [colorCode, setColorCode] = useState(null);
  const [dateFilter, setdateFilter] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dateString, setdateString] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);


  const handleTableChange = (pagination, page) => {
    setCurrentPage(pagination);
    setPageSize(page);
  };

  const [allData, setallData] = useState([]);
  const { TabPane } = Tabs;
  const [selectedData, setselectedData] = useState(null);
  const { VisitorData, Socket } = useContext(SocketContext);
  const pastChatDetails = useSelector((state) => state.PastChat.data);
  const pastChatLoading = useSelector((state) => state.PastChat.isLoading);

  const { Search } = Input;
  const [searchValue, setSearchValue] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const searchInputRef = useRef(null);

  useEffect(() => {
    if (visitorData?.data?.length > 0) {
      setallData(visitorData?.data);
    } else {
      setallData([])
    }
  }, [visitorData]);

  const navigate = useNavigate();

  const onChange = (dates, dateStrings) => {
    if (dates && dates.length === 2) {
      setStartDate(dates[0]);
      setEndDate(dates[1]);
      setdateFilter(dates);
      setdateString(`${dateStrings[0]} - ${dateStrings[1]}`);
    }
    else {
      setStartDate(null);
      setEndDate(null);
      setdateFilter(null);
      setdateString(null);
    }
  };

  useEffect(() => {
    let allTokens = userData?.assignBrands?.map((i) => i?.token);
    if (dateFilter != null && startDate && endDate) {
      let Data = {
        brand_token: allTokens,
        startDate: startDate,
        endDate: endDate,
        currentPage: currentPage,
        pageSize: pageSize

      };
      dispatch(getVisitorAllHistory(Data, usertoken));
    } else {
      // No date filter -> fetch all available history (paginated).
      let Data = {
        brand_token: allTokens,
        currentPage: currentPage,
        pageSize: pageSize
      };
      dispatch(getVisitorAllHistory(Data, usertoken));
    }
  }, [dateFilter, pageSize, currentPage]);

  const rowClassName = (record) => {
    return record.agentParticipants ? 'active-row' : '';
  };

  const columns = [
    {
      title: "Visitor",
      width: 150,
      render: (text, item) => {
        return <div onClick={() => handleRowClick(item)} className="visitorIcon">{text
          ?.name ? text?.name : text?.unique_id}</div>
      }
    },
    {
      title: "Agent",
      width: 150,
      render: (text) => {
        if (text?.current_conversation !== null) {
          return text?.current_conversation?.agentParticipants?.map((i, index) => <div key={index} className="visitorIcon">{i?.sudoName}</div>
          )
        } else {
          return text?.past_conversations?.[text?.past_conversations?.length - 1]?.agentParticipants?.map((i, index) => <div key={index} className="visitorIcon">{i?.sudoName}</div>
          )
        }
      }
    },
    {
      title: 'Time',
      // dataIndex: 'visitor',
      width: 240,
      render: (text) => (
        <div className="visitorIcon">
          {moment.utc(text?.updatedAt).format("DD-MM-YYYY")}
        </div>
      ),
    },
    {
      title: "Messages",
      render: (text) => {
        const totalMessageCount = text.past_conversations?.reduce((acc, convo) => {
          return acc + (convo.message_count || 0);
        }, 0);
        if (text?.current_conversation !== null) {

          return <div className="currentHistoryPage__messageCell">
            <div className="msgBadges">
              {text?.current_conversation?.message_count}
            </div>
            <div className="currentHistoryPage__messageText">
              {text?.current_conversation?.latest_message?.message ? (
                text?.current_conversation?.latest_message?.message
              ) : (
                text?.current_conversation?.latest_message?.file?.filename
              )}
            </div>
          </div>
        } else {
          return <div className="currentHistoryPage__messageCell">
            <div className="msgBadges">
              {totalMessageCount}
            </div>
            <div className="currentHistoryPage__messageText">
              {text.past_conversations?.[0]?.latest_message?.message ? (
                text.past_conversations?.[0]?.latest_message?.message
              ) : (
                text.past_conversations?.[0]?.latest_message?.file?.filename
              )}
            </div>
          </div>
        }
      }
    },
  ];

  useEffect(() => {
    if (isShow) {
      setColorCode(Math.random().toString(16).substr(-6));
    }
  }, [isShow]);

  useEffect(() => {
    if (!isShow || !selectedData?.unique_id || !usertoken) return;
    dispatch(getPastMessages({ unique_id: selectedData.unique_id }, usertoken));
  }, [dispatch, isShow, selectedData?.unique_id, usertoken]);

  useEffect(() => {
    if (!isShow || !selectedData?.unique_id) return;
    const freshRow = allData?.find((row) =>
      visitorsUniqueKeyEqual(row?.unique_id, selectedData?.unique_id)
    );
    if (!freshRow) return;
    setselectedData((prev) => mergeVisitorProfile(prev, freshRow));
  }, [allData, isShow, selectedData?.unique_id]);

  const liveVisitor = useMemo(() => {
    if (!selectedData?.unique_id) return null;
    return VisitorData?.find((visitor) =>
      visitorsUniqueKeyEqual(visitor?.unique_id, selectedData?.unique_id)
    );
  }, [VisitorData, selectedData?.unique_id]);

  const fetchedVisitor = useMemo(() => {
    if (!visitorProfileMatches(pastChatDetails, selectedData?.unique_id)) return null;
    return pastChatDetails;
  }, [pastChatDetails, selectedData?.unique_id]);

  const drawerVisitor = useMemo(
    () => mergeVisitorProfile(selectedData, fetchedVisitor, liveVisitor),
    [selectedData, fetchedVisitor, liveVisitor]
  );

  useEffect(() => {
    if (!Socket || !isShow || !selectedData?.unique_id || !usertoken) return;

    const onVisitorArrive = (data) => {
      if (!visitorsUniqueKeyEqual(data?.unique_id, selectedData?.unique_id)) return;
      setselectedData((prev) => mergeVisitorProfile(prev, data));
      dispatch(getPastMessages({ unique_id: selectedData.unique_id }, usertoken));
    };

    const onVisitorMessage = (data) => {
      const visitorId = data?.senderID ?? data?.reciver ?? data?.receiver;
      if (!visitorsUniqueKeyEqual(visitorId, selectedData?.unique_id)) return;
      dispatch(getPastMessages({ unique_id: selectedData.unique_id }, usertoken));
    };

    Socket.on("VisitorArrive", onVisitorArrive);
    Socket.on(SOCKET_EVENTS.VISITOR_CHAT_TO_BRAND, onVisitorMessage);
    return () => {
      Socket.off("VisitorArrive", onVisitorArrive);
      Socket.off(SOCKET_EVENTS.VISITOR_CHAT_TO_BRAND, onVisitorMessage);
    };
  }, [Socket, dispatch, isShow, selectedData?.unique_id, usertoken]);

  const handleRowClick = (record) => {
    setselectedData(record);
    // upDateIsRead(record?.visitor?.unique_id, record?.visitor?.isRead);
    setisShow(true);
  };

  const handleCloseSidebar = () => {
    setisShow(false);
  };
  const normalizeFilterSpaces = (value) => {
    const keys = ["contact", "channeluser", "message", "visitorID", "assignee", "tag", "updated", "created"];
    const pattern = new RegExp(`\\b(${keys.join("|")})\\s*:\\s+`, "gi");
    return String(value ?? "").replace(pattern, "$1:");
  };

  const onSeachData = (rawData) => {
    let allTokens = userData?.assignBrands?.map((i) => i?.token);
    const data = normalizeFilterSpaces(rawData).trim();
    if (data !== "") {
      let newData = {
        brand_token: allTokens,
        search: data
      };
      dispatch(getBySearch(newData, usertoken));
    }
    else {
      let Data = {
        brand_token: allTokens,
        currentPage: currentPage,
        pageSize: pageSize
      };
      dispatch(getVisitorAllHistory(Data, usertoken));
    }
  }

  const disabledDate = (current) => {
    return current && current > moment().endOf('day');
  };

  const filterSuggestions = [
    { key: "contact", example: "contact: name", desc: "Name of the contact" },
    { key: "channeluser", example: "channeluser: user@exa.com", desc: "Channel identity or address" },
    { key: "message", example: "message: can you help with my invoice?", desc: "Keywords or specific text" },
    { key: "visitorID", example: "visitorID: #98213", desc: "Visitor reference code" },
    { key: "assignee", example: "assignee: name", desc: "Name of the agent or team" },
    { key: "tag", example: "tag: priority", desc: "Tags applied to the ticket" },
    { key: "updated", example: "updated: yesterday", desc: "Last update time" },
    { key: "created", example: "created: last 7 days", desc: "Creation time" },
  ];

  const focusSearchEnd = () => {
    // Input.Search forwards to antd Input; try common locations for the real input node.
    const el =
      searchInputRef?.current?.input ||
      searchInputRef?.current?.resizableTextArea?.textArea ||
      searchInputRef?.current;
    if (el && typeof el.focus === "function") {
      el.focus();
      try {
        if (typeof el.setSelectionRange === "function") {
          const len = (el.value || "").length;
          el.setSelectionRange(len, len);
        }
      } catch (_) {
        // ignore selection errors
      }
    }
  };

  const suggestionDropdown = (
    <div className="currentHistoryPage__suggestions">
      <div className="currentHistoryPage__suggestionsTitle">Suggested Filters</div>
      <div className="currentHistoryPage__suggestionsList">
        {filterSuggestions.map((s) => (
          <div
            key={s.key}
            className="currentHistoryPage__suggestionRow"
          >
            <button
              type="button"
              className="currentHistoryPage__suggestionKey"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => {
                const keys = ["contact", "channeluser", "message", "visitorID", "assignee", "tag", "updated", "created"];
                setSearchValue((prev) => {
                  const trimmed = String(prev ?? "").trim();
                  if (!trimmed) return `${s.key}: `;
                  // if a filter prefix already exists, replace it but keep the typed value
                  const existing = trimmed.match(new RegExp(`^(${keys.join("|")})\\s*:\\s*(.*)$`, "i"));
                  if (existing) {
                    const value = existing[2];
                    return value ? `${s.key}: ${value}` : `${s.key}: `;
                  }
                  // no recognized filter yet -> set this filter, keeping any free text as its value
                  return `${s.key}: ${trimmed}`;
                });
                setSearchOpen(true);
                setTimeout(() => focusSearchEnd(), 0);
              }}
            >
              {s.key}:
            </button>
            <div className="currentHistoryPage__suggestionExample">
              {s.example}
            </div>
            <div className="currentHistoryPage__suggestionDesc">{s.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="table-container-sidebarnew currentHistoryPage">
      <div className="historytopbtn currentHistoryPage__toolbar">
        <Dropdown
          open={searchOpen}
          onOpenChange={(open) => setSearchOpen(open)}
          trigger={["click"]}
          dropdownRender={() => suggestionDropdown}
          placement="bottomLeft"
          getPopupContainer={(trigger) => trigger?.parentElement || trigger}
        >
          <div className="currentHistoryPage__search">
            <Search
              ref={searchInputRef}
              value={searchValue}
              placeholder="Search"
              onChange={(e) => setSearchValue(e.target.value)}
              onClick={() => setSearchOpen(true)}
              onFocus={() => setSearchOpen(true)}
              onSearch={(value) => {
                setSearchOpen(false);
                onSeachData(value);
              }}
              onBlur={() => {
                // close only when focus fully leaves search + dropdown clicks are done
                setTimeout(() => setSearchOpen(false), 150);
              }}
            />
          </div>
        </Dropdown>
        <RangePicker
          className="currentHistoryPage__rangePicker"
          disabledDate={disabledDate}
          format="DD-MM-YYYY"
          onChange={onChange}
          style={{ width: "100%" }}
          getPopupContainer={(trigger) => trigger?.parentElement || trigger}
        />
        {/* <Button onClick={() => navigate("/all-history")} type="primary" >
          All Visitors
        </Button> */}
      </div>
      <Badge.Ribbon text={dateFilter !== null ? dateString : "Today's Record's"} color="rgb(86, 119, 122)">
        <Table
          className="currentHistoryPage__table"
          loading={isLoadingH}
          dataSource={allData?.map((item, index) => ({ ...item, key: index }))}
          columns={columns}
          scroll={{ x: "max-content" }}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            pageSizeOptions: ['10', '20', '50'],
            total: visitorData?.totalCount,
            showTotal: (total, range) => `Total ${total} records | Showing ${range[0]}-${range[1]} records`,
            onChange: handleTableChange,
            showLessItems: true,
            responsive: true,
          }}
          rowClassName={rowClassName}
          onRow={(record, rowIndex) => {
            return {
              onClick: () => handleRowClick(record),
            };
          }}
        />
      </Badge.Ribbon>
      <Drawer
        className="currentHistoryDrawer"
        width={720}
        open={isShow}
        onClose={() => handleCloseSidebar()}
      // extra={
      //   visible && <Button type="primary" onClick={() => onSave()}>Save</Button>
      // }
      >
        <div className="currentHistory">
          <Tabs defaultActiveKey="1" className="currentHistoryTabs">
            <TabPane tab="Transcript" key="1">
              <TransTab
                selectedData={drawerVisitor ?? selectedData}
                colorCode={colorCode}
                isLoading={pastChatLoading}
              />
            </TabPane>
            <TabPane tab="User" key="2">
              <UserTab selectedData={drawerVisitor ?? selectedData} />
            </TabPane>
          </Tabs>
        </div>

      </Drawer>
    </div >
  );
};

export default Currenthistory;